export enum PayoutRequestStatusEnum {
  PENDING = "PENDING",
  PAID = "PAID",
  REJECTED = "REJECT",
}
